<template>
    <div>
        <brand-table ref="table" :url="indexUrl">
            <template v-slot:buttons>
                <button class="btn btn-purple" v-if="canCreate" @click="addBrand">
                    <i class="far fa-file"></i>
                </button>
            </template>
        </brand-table>
        <dialog-form-wrapper></dialog-form-wrapper>
    </div>
</template>

<script>
  import eventBus from '../../event-bus';
  import DialogFormWrapper from './dialog-form-wrapper';
  import BrandTable from '../../components/brand/table';

  export default {
    components: {
      DialogFormWrapper,
      BrandTable,
    },

    props: {
      indexUrl: null,
      createUrl: null,
      canCreate: {
        type: Boolean,
        default: false
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.table.refresh();
      },

      /**
       * @event show-add-brand-dialog
       */
      addBrand() {
        eventBus.$emit('show-add-brand-dialog', this.createUrl);
      },


    },

    created() {
      eventBus.$on('refresh-brands-table', this.refresh);
    },

    beforeDestroy() {
      eventBus.$off('refresh-brands-table', this.refresh);
    }
  }
</script>

